

const ANNUAL_REPORTS_IPO_LINKS = {
  // ANNUAL_REPORTS_19_20: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2019-20.pdf',
  ANNUAL_REPORTS_20_21: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2020-21.pdf',
  ANNUAL_REPORTS_21_22: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2021-22.pdf',
  ANNUAL_REPORTS_22_23: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2022-23.pdf',
};

const ANNUAL_REPORTS_IPO = Object.freeze({
  ANNUAL_REPORTS: [
    // {
    //   id: 0,
    //   title: 'Annual Report - 2019-20',
    //   dataUrl: ANNUAL_REPORTS_IPO_LINKS.ANNUAL_REPORTS_19_20,
    // },
    {
      id: 0,
      title: 'Annual Report - 2020-21',
      dataUrl: ANNUAL_REPORTS_IPO_LINKS.ANNUAL_REPORTS_20_21,
    },
    {
      id: 1,
      title: 'Annual Report - 2021-22',
      dataUrl: ANNUAL_REPORTS_IPO_LINKS.ANNUAL_REPORTS_21_22,
    },
    {
      id: 2,
      title: 'Annual Report - 2022-23',
      dataUrl: ANNUAL_REPORTS_IPO_LINKS.ANNUAL_REPORTS_22_23,
    },
  ],
});

export {
  ANNUAL_REPORTS_IPO,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/AnnualReports/constants.jsx